
export const ParkingGroupingMasterHeading = (t) => [
  { title: t("Parking Grouping Name"), field: "name" },
  { title: t("Property Name"), field: "property" },
  { title: t("Description"), field: "description" },
  { title: t("Status"), field: "status" },
  { title: "", field: "icon" },
];
export const ParkingGroupingMasterPath = ["name", "property", "description", "status"];
